<template>
    <el-dialog
      :title="!dataForm.id ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="viewData.visible">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="100px" class="org-dialog-form">
        <el-row :gutter="10">

          <el-col :span="12">
            <el-form-item label="物料代码" prop="materialGroupCode">
              <el-input v-model="dataForm.materialGroupCode" placeholder="物料代码"></el-input>
            </el-form-item>          
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称" prop="materialGroupName">
              <el-input v-model="dataForm.materialGroupName" placeholder="物料名称"></el-input>
            </el-form-item>          
          </el-col>
    
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="父节点名称" prop="parentName">
              <el-input 
                v-model="dataForm.parentName" 
                ref="parentname"
                :readonly="true"
                placeholder="父节点名称">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 新增：是否为叶节点单选框 -->
            <el-form-item label="是否为叶节点" prop="isLeaf"  label-width="120px">
              <el-radio-group v-model="dataForm.isLeaf">
                <el-radio :label=1>是</el-radio>
                <el-radio :label=0>否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="租户" prop="tenantName">
              <el-input v-model="dataForm.tenantName" :readonly="true" placeholder="请选择租户" style="width: 100%">
              </el-input>
            </el-form-item>         
          </el-col> -->
        </el-row>
        <el-row v-if="false">
          <el-col :span="24" >
            <el-form-item label="路径" prop="nodePath">
              <el-input v-model="dataForm.nodePath" readonly placeholder="路径"></el-input>
            </el-form-item>  
          </el-col>
        </el-row>  
      </el-form>
      <el-row :gutter="40">
        <el-col :span="24" style="text-align:right;">
          <el-button size="small" @click="viewData.visible = false">
            取消
          </el-button>
          <el-button size="small" type="primary" @click="dataFormSubmit()">
            确定
          </el-button>        
        </el-col>
      </el-row>
    </el-dialog>
  </template>
  
  <script>
    import {getOrgById, createMtl, editMtl} from '@/controller/mdata'
    export default {
      data () {
        return {
          viewData: {
            visible: false,
            width:''
          },
          dataForm: {
            id: 0,
            materialGroupName: '',
            materialGroupCode: '',
            parentId: '',
            parentName: '',
            parentNodePath: '',
            tenantId: '',
            tenantName: '',
            isLeaf: 0
          },
          dataRule: {
            name: [
              { required: true, message: '物料名称不能为空', trigger: 'blur' }
            ],
            code: [
              { required: true, message: '物料代码不能为空', trigger: 'blur' }
            ],
            tenantName: [
              { required: true, message: '请先在页面顶部导航栏选择租户', trigger: 'blur' }
            ]
          }
        }
      },
      mounted () {
        console.log("guazai",this.$refs)
      },
      methods: {
        init (row) {
          let id = null;
          let parentId = null;
          let parentName = null;
          let parentNodePath = null;
          let isLeaf = null;
          if(row != null){
            id = row.id
            parentId = row.parentId
            parentName = row.parentName
            parentNodePath = row.parentNodePath
            isLeaf = row.isLeaf
          }
          this.dataForm.id = id || 0
          this.dataForm.parentId = parentId || 0
          this.viewData.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            this.dataForm.tenantName = sessionStorage.getItem('tenantName')
            if (this.dataForm.id) {
              // getOrgById(
              //         {},this.dataForm.id
              // ).then(data => {
              //   if (data && data.code === '00') {
              //     this.dataForm.name = data.body.orgName
              //     this.dataForm.code = data.body.orgCode
              //     this.dataForm.parentId = data.body.parentId
              //     this.dataForm.parentName = data.body.parentName
              //   }
              // })
              
              this.dataForm.materialGroupCode = row.materialGroupCode
              this.dataForm.materialGroupName = row.materialGroupName
              this.dataForm.parentName = row.parentName
              this.dataForm.isLeaf = row.isLeaf
            }else{
              console.log("id",this.dataForm.parentId)
              this.dataForm.parentId = parentId ? parentId : 0
              this.dataForm.parentName = parentName ? parentName : '根节点'
              this.dataForm.parentNodePath = parentNodePath ? parentNodePath : ''
            }
          })
        },
        // 表单提交
        dataFormSubmit () {
          this.$refs['dataForm'].validate((valid) => {
            if (valid) {
                
              let params = {
                'id': this.dataForm.id || undefined,
                'materialGroupName': this.dataForm.materialGroupName,
                'materialGroupCode': this.dataForm.materialGroupCode,
                'parentId': this.dataForm.parentId,
                'parentName': this.dataForm.parentName,
                'parentNodePath': this.dataForm.parentNodePath,
                'isLeaf': this.dataForm.isLeaf
              }

              
              if(this.dataForm.id){
                editMtl(params).then(data => {
                  if (data && data.code === '00') {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      onClose: () => {
                        this.viewData.visible = false
                        this.$emit('refreshDataList')
                      }
                    })
                  } else {
                    this.$message.error(data.msg)
                  }
                })
              }else{
                createMtl(params).then(data => {
                  if (data && data.code === '00') {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      onClose: () => {
                        this.viewData.visible = false
                        this.$emit('refreshDataList')
                      }
                    })
                  } else {
                    this.$message.error(data.msg)
                  }
                })
              }
            }
          })
        }
      }
    }
  </script>
  
  
  <style lang="scss">
    .el-dialog__body{
      .org-dialog-form{
        width: 95%;
      }
    }
  </style>